import { Button, ButtonType, TextInput } from '@resurs-internal/styx-react'
import React, { useEffect, useRef, useState } from 'react'
import { TokenStream } from '../common/flowevents'
import { useQuery } from '../common/utils'
import styles from './Auth.module.scss'

// doAuth | failAuth
const mockAuth = (result, token, govId) => {
  window.location.href = `${process.env.REACT_APP_CHECKPOINT_MOCK_PROXY_PATH}/mock/${result}?resursToken=${token}&govId=${govId}`
}

const getGovId = token =>
  fetch(
    `${process.env.REACT_APP_CHECKPOINT_MOCK_PROXY_PATH}/mock/authenticate?resursToken=${token}`,
    { credentials: 'omit' },
  )
    .then(r => r.text())
    .then(r =>
      new DOMParser()
        .parseFromString(r, 'text/html')
        .getElementsByName('govId')?.[0]
        .getAttribute('value'),
    )

export const Auth = () => {
  const { resursToken: token, altUrl } = useQuery()
  const streamRef = useRef(null)
  const [initiated, setInitiated] = useState(false)
  const [govId, setGovId] = useState()
  const [isDisabled, setIsDisabled] = useState(false)

  const goTo = url => {
    streamRef.current?.close()
    window.location.href = url
  }

  const handleEvent = ({ type, object }) => {
    if (type === 'FLOW') {
      if (object.currentTask?.taskType === 'AUTHENTICATION') {
        console.log('auth is current')
      } else {
        goTo(object.flowUrl)
      }
    }
  }

  useEffect(() => {
    streamRef.current = new TokenStream(
      process.env.REACT_APP_SIGNING_FLOW_PROXY_PATH,
      token,
    ).onMessage(event => {
      handleEvent(event)
    })
    getGovId(token).then(prefilledGovId => {
      setGovId(prefilledGovId)
      if (prefilledGovId?.length) {
        setIsDisabled(true)
      }
      setInitiated(true)
    })
    return () => streamRef.current?.close()
  }, [])

  if (!initiated) {
    return <p>Loading...</p>
  }

  return (
    <>
      <h1>Authentication</h1>
      {isDisabled ? (
        <p>The government ID of the authenticating person is</p>
      ) : (
        <p>Enter government ID of authenticating person</p>
      )}
      <div className={styles.lineWrapper}>
        <TextInput
          id="govId"
          label="Government ID"
          value={govId}
          disabled={isDisabled}
          onChange={(name, value) => setGovId(value)}
        />
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="successButtonId"
          fullWidth
          onClick={() => {
            streamRef.current?.close()
            mockAuth('doAuth', token, govId)
          }}
        >
          Authenticate
        </Button>
      </div>
      <div className={styles.lineWrapper}>
        <Button
          id="failureButtonId"
          type={ButtonType.Secondary}
          fullWidth
          onClick={() => {
            streamRef.current?.close()
            mockAuth('failAuth', token, govId)
          }}
        >
          Cancel
        </Button>
      </div>
      {!altUrl && token && (
        <div className={styles.lineWrapper}>
          <Button
            id="signicatButtonId"
            type={ButtonType.Secondary}
            fullWidth
            onClick={() => {
              streamRef.current?.close()
              mockAuth('authToSignicat', token, govId)
            }}
          >
            Use Signicat
          </Button>
        </div>
      )}
    </>
  )
}
